import React from 'react';

import { Clock, User } from 'react-feather';

const THEME = { solid: '#0d6efd', tint: '#e7f1ff', dark: '#0a58ca' };

export default function RedmineTickets({ organization_name, data }) {
  const t = THEME;

  return (
    <a
      href={`/organizations/${organization_name}/issues/${data?.id}`}
      className='d-block text-decoration-none mb-2'
      style={{ color: 'inherit' }}
    >
      <div
        className='bg-white border rounded p-3'
        style={{
          borderLeft: `3px solid ${t.solid}`,
          transition: 'box-shadow 0.15s, transform 0.15s',
          cursor: 'pointer',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
          e.currentTarget.style.transform = 'translateY(-1px)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.boxShadow = 'none';
          e.currentTarget.style.transform = 'none';
        }}
      >
        <div className='d-flex justify-content-between align-items-start mb-2'>
          <span className='text-muted fw-bold' style={{ fontSize: 12 }}>
            #{data?.id}
          </span>
          <span
            style={{
              background: t.tint,
              color: t.dark,
              fontSize: 11,
              fontWeight: 500,
              padding: '4px 8px',
              borderRadius: 4,
              border: `1px solid ${t.solid}33`,
            }}
          >
            {data?.tracker_name}
          </span>
        </div>

        <p className='text-dark mb-3' style={{ fontSize: 14, lineHeight: 1.4 }}>
          {data?.subject}
        </p>

        <div
          className='d-flex justify-content-between align-items-center text-muted'
          style={{ fontSize: 12 }}
        >
          <span className='d-inline-flex align-items-center'>
            <Clock size={12} className='me-1' /> {data?.updated_on}
          </span>
          <span className='d-inline-flex align-items-center text-truncate' style={{ maxWidth: '55%' }}>
            <User size={12} className='me-1 flex-shrink-0' />
            <span className='text-truncate'>{data?.author_name}</span>
          </span>
        </div>
      </div>
    </a>
  );
}
